"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerDealLabel = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _common = require("../../common");
var _jsxRuntime = require("react/jsx-runtime");
const InnerDealLabel = ({
  label,
  type,
  productCode,
  tooltipTitle,
  size = 'medium'
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const labelComponent = (0, _react.useCallback)(() => {
    switch (type) {
      case 'Offer':
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Chip, {
          label: label,
          size: size,
          color: "offer",
          variant: "tag",
          "data-testid": `${getTestId(_common.LABEL_OFFER)}-${productCode}`
        });
      case 'SuperDeal':
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Chip, {
          label: label,
          size: size,
          color: "offer",
          variant: "tag",
          "data-testid": `${getTestId(_common.LABEL_SUPER_DEAL)}-${productCode}`
        });
      case 'NewEditionAvailable':
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Chip, {
          label: label,
          size: size,
          color: "primary",
          "data-testid": `${getTestId(_common.NEW_EDITION_AVAILABLE_LABEL)}-${productCode}`
        });
      case 'NewEdition':
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Chip, {
          label: label,
          size: size,
          color: "primary",
          "data-testid": `${getTestId(_common.NEW_EDITION_LABEL)}-${productCode}`
        });
      case 'New':
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Chip, {
          label: label,
          size: size,
          color: "primary",
          "data-testid": `${getTestId(_common.LABEL_NEW)}-${productCode}`
        });
      default:
        return null;
    }
  }, [getTestId, label, productCode, size, type])();
  if (!labelComponent) {
    return null;
  }
  return tooltipTitle ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
    arrow: true,
    placement: "top-start",
    title: tooltipTitle,
    children: labelComponent
  }) : labelComponent;
};
exports.InnerDealLabel = InnerDealLabel;
//# sourceMappingURL=InnerDealLabel.js.map